import {
    ApartmentOutlined,
    ContactPhoneOutlined,
    GroupOutlined,
    PeopleAltOutlined,
    PaymentOutlined,
    LiveHelpOutlined,
    ContactsOutlined,
    AccountTreeOutlined,
    PersonOutlined,
    DirectionsRunOutlined,
    SettingsOutlined,
    ImportContacts,
    NotificationsNone,
    HomeOutlined,
    ViewColumnOutlined,
    EventNoteOutlined,
    MailOutlined,
    ImportExport,
    CollectionsBookmarkOutlined,
    InsertChartOutlined
} from "@material-ui/icons";
import React from "react";
import { Route, UserRoute } from "@onpreo/components";
import { generateDefaultPipelineRoutes } from "./routes-generation-helper";
import { FEATURE_MMCENTER } from "../../utils/secrets";
import { planToTier } from "../../utils/subscription-limits/plan-tiers";
import { priceToLicense } from "../../api/util/stripe/stripe-secrets";

const mailConnectedRoutes = ["create", "drafts", "junk", "sent", "trash", "automated"];
const createSteps = ["", "?step=0", "?step=1", "?step=2", "?step=3"];
const marketingMailConnectedRoutes = [
    "marketing-mail-templates",
    "marketing-mail-template-create",
    "marketing-mails-list",
    "create-campaign",
    "marketing-contact-lists",
    ...createSteps.map(step => `create-automation${step}`)
];

const automationCentersViews = [
    {
        name: "Mail Center",
        path: "/automation-center/mail-center",
        inner: 1,
        connectedPath: ["/automation-center/mail-templates", "/automation-center/mail-template-create"]
    },
    {
        name: "Aktivitäten Center",
        path: "/automation-center/activity-center",
        inner: 1,
        connectedPath: ["/automation-center/activity-templates"]
    },
    {
        name: "Pipeline Center",
        path: "/automation-center/pipeline-center",
        inner: 1
    }
];

export const routes = workspace =>
    [
        { divider: true },
        { title: "Makler" },
        { name: "Home", path: "/profile", icon: <HomeOutlined /> },
        { name: "Immobilien", path: "/real-estate", icon: <ApartmentOutlined /> },
        {
            name: "Pipelines",
            collapse: true,
            state: "Pipelines",
            icon: <ViewColumnOutlined />,
            views: generateDefaultPipelineRoutes(workspace),
            restrictedFeature: "accessPipelinesView"
        },
        {
            name: "Kontakte",
            path: "/leads",
            icon: <PeopleAltOutlined />,
            connectedPath: ["/contacts", "/prospective-buyers", "/prospective-buyers-leads", "/network-partner"]
        },
        {
            name: "Aktivitäten",
            path: "/activities",
            icon: <EventNoteOutlined />,
            connectedPath: ["/activities/calendar"],
            restrictedFeature: "accessActivitiesView"
        },
        {
            name: "Analytics",
            collapse: true,
            icon: <InsertChartOutlined />,
            views: [
                {
                    name: "Marketing Report",
                    path: "/analytics/marketing-campaign",
                    inner: 1
                },
                {
                    name: "Sales statistics",
                    path: "/analytics/sales-statistics",
                    inner: 1
                }
            ],
            restrictedFeature: "accessShowReports"
        },
        {
            name: "E-Mails",
            path: "/mailing/mailbox",
            icon: <MailOutlined />,
            connectedPath: mailConnectedRoutes.map(route => `/mailing/${route}`)
        },
        {
            name: "Automation Center",
            collapse: true,
            state: "Automation Center",
            icon: <CollectionsBookmarkOutlined />,
            views: FEATURE_MMCENTER
                ? [
                      ...automationCentersViews,
                      {
                          name: "Marketing Mail Center",
                          path: "/automation-center/marketing-mail-center",
                          inner: 1,
                          connectedPath: marketingMailConnectedRoutes.map(route => `/automation-center/${route}`)
                      }
                  ]
                : automationCentersViews,
            restrictedFeature: "accessAutomationCenterView"
        },
        // { name: "Preis-Finder", path: "/price-assistant-mode", icon: <EuroSymbol /> },
        // Will only be visible for users that booked it in the future, so will comment out for now
        // { divider: true },
        // { title: "Marketinginhalte" },
        // { name: "Lead Generatoren", path: "/lead-generator", icon: <Filter /> },
        // { name: "Exklusive Inhalte", path: "/premium-content", icon: <GavelOutlined />, showChip: true },
        { divider: true },
        { title: "Eigentümer" },
        { name: "Maklerprofil", path: "/guest-agent-config", icon: <ContactPhoneOutlined /> }
        // { name: "Eigentümer Dashboard", href: INFO_LINKS.OWNER_DASHBOARD.href, icon: <ContactsOutlined /> }
        // { name: "Preisfinder", path: "/price-assistant-config", icon: <AttachMoneyOutlined /> }
        // { divider: true },
        // { title: "Einstellungen" },
        // { name: "Lizenz", path: "/billing", icon: <Settings /> }
        // { divider: true },
        // { title: "FAQ" },
    ].filter(Boolean) as Route[];

export const userRoutes = [
    { name: "Profil bearbeiten", path: "/profile/edit", icon: PersonOutlined },
    { name: "Einstellungen", path: "/settings", icon: SettingsOutlined },
    { name: "Anbindungen", path: "/profile/integrations", icon: AccountTreeOutlined },
    { name: "Team-Management", path: "/settings/team", icon: GroupOutlined },
    { name: "Marketing Contents", path: "/marketing-contents", icon: ImportContacts },
    // TODO: Restrict user access like in sidebar
    { name: "Datenverwaltung", path: "/integrations", icon: ImportExport },
    // { name: "Settings", path: "/settings", icon: Settings },
    { name: "Zahlungen", path: "/billing", icon: PaymentOutlined },
    // { name: "Help Center", path: "https://intercom.help/onpreo/de/", icon: HelpOutline },
    { name: "Notification Center", path: "/notification-center", icon: NotificationsNone },
    {
        name: "Support",
        path: "https://intercom.help/onpreo/de/",
        icon: LiveHelpOutlined,
        isExternal: true
    },
    // { divider: true },
    { name: "Logout", path: "/logout", icon: DirectionsRunOutlined }
] as UserRoute[];

// Filter out undefined routes (for feature flags)
// export default routes.filter(Boolean);
